import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from '../../../EmptyState';
import DeviationSelector from '../FeaturedDeviationConfigPopover/DeviationPicker';
import {
  PapiRequestGruserModuleFeaturedDeviationSave,
  PapiRequestGruserModuleFeaturedPostSave,
} from '@wix/da-papi-types';
import { useModuleConfig } from '@wix/da-gruser-shared/pkg/hooks/useModuleConfig';
import { useModuleName } from '@wix/da-gruser-shared/pkg/hooks/useModule';
import snakeCase from 'lodash/snakeCase';

interface Props {
  moduleId: number;
}

const FeaturedDeviationEmpty: React.FC<Props> = ({ moduleId }) => {
  const moduleName = useModuleName(moduleId);
  const moduleNameSnakeCase = snakeCase(moduleName);
  const { t } = useTranslation();

  const { saveModuleConfig } = useModuleConfig(moduleId, moduleNameSnakeCase);

  const [showingDeviationSelector, setShowingDeviationSelector] =
    useState(false);

  return (
    <>
      <EmptyState
        view="large"
        title={t(`widgets.${moduleNameSnakeCase}.empty.title.owner`)}
        subtitle={t(`widgets.${moduleNameSnakeCase}.empty.subtitle.owner`)}
        withButton
        buttonLabel={t(`widgets.${moduleNameSnakeCase}.empty.CTALabel.owner`)}
        onButtonClick={() => setShowingDeviationSelector(true)}
      />
      {showingDeviationSelector && (
        <DeviationSelector
          type={moduleName === 'featuredDeviation' ? 'regular' : 'posts'}
          onClose={() => setShowingDeviationSelector(false)}
          onSelect={selected => {
            setShowingDeviationSelector(false);
            const deviation = selected[0];
            let params = {} as any;
            if (moduleName === 'featuredDeviation') {
              const featuredDeviationParams: Partial<PapiRequestGruserModuleFeaturedDeviationSave> =
                {
                  deviationid: deviation?.deviationId,
                };
              params = featuredDeviationParams;
            } else {
              const featuredPostParams: Partial<PapiRequestGruserModuleFeaturedPostSave> =
                {
                  itemid: deviation?.deviationId,
                  typeid: deviation?.typeId,
                };
              params = featuredPostParams;
            }
            saveModuleConfig(params);
          }}
        />
      )}
    </>
  );
};
FeaturedDeviationEmpty.displayName = 'FeaturedDeviationEmpty';

export default FeaturedDeviationEmpty;
